import React from 'react'
import { IconButton } from '@common/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Flex, BoxProps } from '@fundamentals'

interface CarouselNavigationProps extends BoxProps {
  onPrevious: () => void
  onNext: () => void
}

const CarouselNavigation: React.FC<CarouselNavigationProps> = ({
  onPrevious,
  onNext,
  ...props
}) => {
  return (
    <Flex
      position='absolute'
      top='45%'
      left={0}
      right={0}
      justifyContent='space-between'
      {...props}
    >
      <IconButton
        onClick={onPrevious}
        sx={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
          },
        }}
      >
        <ChevronLeftIcon />
      </IconButton>
      <IconButton
        onClick={onNext}
        sx={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
          },
        }}
      >
        <ChevronRightIcon />
      </IconButton>
    </Flex>
  )
}

export default CarouselNavigation
